import React from 'react';
import PropTypes from 'prop-types';
import {facilitatorUiTexts} from 'data/ui-texts';
import {resourcesData} from 'data/resources-data';
import './resources-popup.scss';

const ResourcesPopup = ({toggleResourcesPopup}) => {

	return (
		<div className="ResourcesPopup" onClick={() => {toggleResourcesPopup(null);}}>
			<div className="ResourcesPopup-content" onClick={(e) => {e.stopPropagation();}}>
				<div className="ResourcesPopup-header">
					<div className="ResourcesPopup-title">
						{facilitatorUiTexts.resources}
					</div>
				</div>
				<div className="ResourcesPopup-body">
					<div className="ResourcesPopup-resourceGroup">
						<div className="ResourcesPopup-text"><span>{facilitatorUiTexts.view}:</span></div>
						<div className="ResourcesPopup-buttons view">
							{resourcesData.view.map((file, index) => {
								return (
									<a 
										key={index}
										className={'ResourcesPopup-button'}
										href={'/files/' + file.file} 
										target="_blank"
										rel="noopener noreferrer" 
									><span>{file.title}</span></a>
								);
							})}
						</div>
					</div>
					<div className="ResourcesPopup-resourceGroup">
						<div className="ResourcesPopup-text"><span>{facilitatorUiTexts.download}:</span></div>
						<div className="ResourcesPopup-buttons download">
							{resourcesData.download.map((file, index) => {
								return (
									<a 
										key={index}
										className={'ResourcesPopup-button'}
										href={'/files/' + file.file} 
										download
										rel="noopener noreferrer" 
									><span>{file.title}</span></a>
								);
							})}
						</div>
					</div>
				</div>				
			</div>
		</div>
	);
};

ResourcesPopup.propTypes = {
	toggleResourcesPopup: PropTypes.func.isRequired
};

export default ResourcesPopup;
